import { Skeleton } from '@progress/kendo-react-indicators';
import styles from './Skeletons.module.css';

interface SkeletonRowConfig {
  /** Visual indent in px (mimics tree depth). */
  indent: number;
  /** Width of the skeleton bar in px. */
  width: number;
}

const ROWS: SkeletonRowConfig[] = [
  { indent: 0, width: 180 },
  { indent: 16, width: 150 },
  { indent: 32, width: 220 },
  { indent: 32, width: 200 },
  { indent: 32, width: 240 },
  { indent: 32, width: 190 },
  { indent: 48, width: 170 },
  { indent: 48, width: 210 },
  { indent: 48, width: 160 },
  { indent: 48, width: 230 },
];

/**
 * Visual placeholder shown in place of the document tree while the initial
 * data load is in flight. Mimics the tree's nested layout with a handful
 * of pulsing skeleton bars at varying indents and widths so the user sees
 * the structure of what is about to appear.
 */
const TreeSkeleton = () => (
  <div className={styles['tree-skeleton']} role="status" aria-label="Loading documents">
    {ROWS.map((row, idx) => (
      <div
        key={idx}
        className={styles['tree-skeleton-row']}
        style={{ paddingLeft: row.indent }}
      >
        <Skeleton shape="rectangle" style={{ width: 16, height: 16, borderRadius: 3 }} />
        <Skeleton shape="text" style={{ width: row.width, height: 14 }} />
      </div>
    ))}
  </div>
);

export default TreeSkeleton;
